import * as Yup from "yup";

// userSchema
export const userSchema = Yup.object().shape({
  loginID: Yup.string().required("아이디를 입력하세요"),
  loginPW: Yup.string().required("비밀번호를 입력하세요"),
  auto: Yup.boolean(),
  // .min(6, "Username must be at least 6 characters")
  // .max(20, "Username must not exceed 20 characters"),
});
